import React from 'react';
import PropTypes from 'prop-types';
import {Icons} from '../../../index';

const propTypes = {
	// override for search icon
	filterIcon: PropTypes.func,

	// onChange callback (field, value) => do whatever you want; field/value is for DelayedInput
	onChange: PropTypes.func.isRequired,

	// the value to show
	value: PropTypes.string.isRequired,
};

const defaultProps = {
	filterIcon: undefined,
};

export default class FilterDetailInput extends React.Component {
	render() {
		return (
			<React.Fragment>
				{this.props.filterIcon ? this.props.filterIcon('filter-icon') : Icons.iconSearch('filter-icon')}
				<input
					type="text"
					placeholder="Filter"
					className="filter-input"
					value={this.props.value}
					onChange={e => this.props.onChange(undefined, e.target.value)}
				/>
			</React.Fragment>
		);
	}
}

FilterDetailInput.defaultProps = defaultProps;
FilterDetailInput.propTypes = propTypes;